import {EndpointBuilder} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {createApi} from '@reduxjs/toolkit/query/react';
import {createProgramFileEndpoint} from './endpoints/programFile.endpoint';
import {createXmlEndpoint} from './endpoints/tvGuide.endpoint';
import {freeBaseQueryFn} from './traceBaseQuery';

export type FreeApiEndpointBuilder = EndpointBuilder<
  typeof freeBaseQueryFn,
  never,
  'freeApi'
>;

// Define a service using a base URL and expected endpoints
export const freeApi = createApi({
  reducerPath: 'freeApi',
  baseQuery: freeBaseQueryFn,
  endpoints: builder => ({
    ...createXmlEndpoint(builder),
    ...createProgramFileEndpoint(builder),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useLazyGetTvGuideXmlQuery, useLazyGetProgramFileQuery} = freeApi;
